import _extends from "@babel/runtime/helpers/extends";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import FieldFrame from "../FieldFrame";
import styles from "./Input.module.css";
const Input = /*#__PURE__*/React.forwardRef(function Input(props, ref) {
  const {
    className,
    label,
    errorMessage,
    hasError,
    disabled,
    size,
    style,
    icon,
    isLoading,
    withShadow,
    isRtl,
    ...inputProps
  } = props;
  return /*#__PURE__*/React.createElement(FieldFrame, {
    label: label,
    className: cx(className, styles.input),
    errorMessage: errorMessage,
    hasError: hasError,
    disabled: disabled,
    value: inputProps.value,
    size: size,
    icon: icon,
    isLoading: isLoading,
    isRtl: isRtl
  }, /*#__PURE__*/React.createElement("input", _extends({
    style: style,
    disabled: disabled
  }, inputProps, {
    forwardedRef: ref
  })));
});
Input.propTypes = {
  withShadow: PropTypes.bool,
  icon: PropTypes.element,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  errorMessage: PropTypes.string,
  isLoading: PropTypes.bool,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  isRtl: PropTypes.bool
};
Input.defaultProps = {
  icon: null,
  className: null,
  label: null,
  hasError: false,
  disabled: false,
  errorMessage: null,
  size: "md",
  style: {},
  isLoading: false,
  isRtl: false,
  withShadow: false
};

const _default = /*#__PURE__*/React.memo(Input);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Input, "Input", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/Input/Input.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/Input/Input.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();